export interface IDataGridCommitEvent {
	order: Order;
	key: string;
}

export enum Order {
	Add = 'add',
	Edit = 'edit',
	Delete = 'delete'
}
